import { useTranslations } from "@jugl-web/utils";
import { FC } from "react";
import { AppearanceSettingsTabShell } from "../AppearanceSettingsTabShell";
import { Separator } from "../../../../components/Separator";
import { TabHeader } from "../../../../components/TabHeader";
import { BrandingSection } from "./BrandingSection";
import { ChatAppearanceSection } from "./ChatAppearanceSection";

export const GeneralSetupTabContent: FC = () => {
  const { t } = useTranslations();

  return (
    <AppearanceSettingsTabShell tabId="generalSetup" previewMode="default">
      <TabHeader
        title={t({
          id: "client-support-page.general-setup-tab-title",
          defaultMessage: "General Setup",
        })}
        subtitle={t({
          id: "client-support-page.general-setup-tab-subtitle",
          defaultMessage: "Set the naming and style of your Web Chat",
        })}
      />
      <Separator className="my-8" />
      <div className="flex flex-col gap-14">
        <BrandingSection />
        <ChatAppearanceSection />
      </div>
    </AppearanceSettingsTabShell>
  );
};
